import { schemaMatches, and, isEnumControl, rankWith } from '@jsonforms/core'

export default rankWith(
  21, //increase rank as needed
  and(
    isEnumControl,
    schemaMatches(
      // eslint-disable-next-line
      (schema: { hasOwnProperty: (arg0: string) => any }) =>
        // eslint-disable-next-line no-prototype-builtins
        schema.hasOwnProperty('isCustomRadio') ||
        // eslint-disable-next-line no-prototype-builtins
        schema.hasOwnProperty('isCustomRadioButtons')
    )
  )
)
